import React from "react";
import { Form, Field, InputSubmit, Select } from "./ui/Form";
import styled from "@emotion/styled";


const Input = styled.input`
  flex: 1;
  padding: 1rem;
  border: none;
  font-family: "Lato", sans-serif;
  margin-left: 1rem;
`;

const Container = styled.div`

  font-size: 2rem;
  @media (max-width: 768px) {
    font-size: inherit;
  }
  text-align: center;
  display: flex;
  flex-direction: column;
    
    align-items: center;
    justify-content: space-between;
    padding: 2rem;

  }
`;
const Donate = () => {
  return (
    <Container>
      <div>
        <Form
          // onSubmit={handleSubmit}
          noValidate
        >
                <h2>  Why do we need your donation?</h2>
                <div className="header">
        When someone donates to help cats in need using our site, 100 percent of
        the donations are used to take care of them. In turn, the leading funder
        of the organisation effectively uses every dollar raised to fund its
        mission: <br />
        <b>
          To find lifelong, loving homes for all pets by supporting programs and
          thought leadership that bring people and pets together.
        </b>
      </div>
          <fieldset>
            <Field>
              I would like to do a <br/>
              <Select>
                <option name="monthly" value="monthly">
                  Monthly Donation
                </option>
                <option name="offset">One-Off Donation</option>
              </Select>
            </Field>
            <Field>
              of U$S <br />
              <Input type="number" name="donation" />
            </Field>
            <InputSubmit type="submit" value="DONATE" />
          </fieldset>
        </Form>
      </div>
    </Container>
  );
};

export default Donate;
